export class BreadcrumbError extends Error {}
